exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".lbaTagSelect_list{margin:1rem 0}.lbaTagSelect_uiSelect{display:inline-block;width:30rem;margin:0 1rem 0 0}.lbaTagSelect_uiSelect .form-control{width:100%}", "", {"version":3,"sources":["/../../../../../sassjs-loader/index.js!/home/vsts/work/1/s/src/components/lbaTagSelect/lbaTagSelect.scss"],"names":[],"mappings":"AAAA,mBACE,aAAe,CAAE,AAEnB,uBACE,qBAAsB,AACtB,YAAa,AACb,iBAAmB,CAAE,AACrB,qCACE,UAAY,CAAE","file":"lbaTagSelect.scss","sourcesContent":[".lbaTagSelect_list {\n  margin: 1rem 0; }\n\n.lbaTagSelect_uiSelect {\n  display: inline-block;\n  width: 30rem;\n  margin: 0 1rem 0 0; }\n  .lbaTagSelect_uiSelect .form-control {\n    width: 100%; }\n"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap!./~/sassjs-loader!./src/components/lbaTagSelect/lbaTagSelect.scss
// module id = 425
// module chunks = 0